<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/PM'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
              v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM', 
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <label>Agent:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMAgentCode'"
                    :name="'rePMAgentCode'"
                    :select2-options="rePMAgentCodeOptions"
                    v-model="rePMAgentCode"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="rePMAgentCode"
                    :multiple="true"
                    :options="rePMAgentCodeOptions"
                    v-on:open="LoadrePMAgentCodeOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
              v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  <!-- <label>Agent:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMAgentCode'"
                    :name="'rePMAgentCode'"
                    :select2-options="rePMAgentCodeOptions"
                    v-model="rePMAgentCode"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="rePMSubAgentCode"
                    :multiple="true"
                    :options="rePMSubAgentCodeOptions"
                    v-on:open="LoadrePMSubAgentCodeOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <label>Region:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMRegion'"
                    :name="'rePMRegion'"
                    :select2-options="rePMRegionOptions"
                    multiple
                    v-model="rePMRegion"
                  ></select2> -->
                  <treeselect
                    v-model="rePMRegion"
                    :multiple="true"
                    :options="rePMRegionOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อผู้ใช้งาน:</label>
                  <!-- <label>User name:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMCreatedUserId'"
                    :name="'rePMCreatedUserId'"
                    :select2-options="rePMCreatedUserIdOptions"
                    v-model="rePMCreatedUserId"
                    multiple
                  ></select2> -->
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMCreatedUserId'"
                    :name="'rePMCreatedUserId'"
                    :select2-options="pmrPmUserIdOptions"
                    v-model="rePMCreatedUserId"
                    multiple
                    ref="rePMCreatedUserIdSelect2"
                  ></select2>
 
<!-- 
                  <treeselect
                    v-model="rePMCreatedUserId"
                    :multiple="true"
                    :options="pmrPmUserIdOptions" 
                    placeholder="กรุณาเลือก"
                  /> -->
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label>วันที่การล้างเครื่อง(PM)(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="rePMDateStart"
                      name="rePMDateStart"
                      ref="rePMDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                  <span class="text-danger small" v-if="rePMDateStartError">{{ rePMDateStartError }}</span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>วันที่การล้างเครื่อง(PM)(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="rePMDateEnd"
                      name="rePMDateEnd"
                      ref="rePMDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                  <span class="text-danger small" v-if="rePMDateEndError">{{ rePMDateEndError }}</span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>BARCODE (เครื่องทำความเย็น):</label>
                  <input
                    v-model="rePMBarcode"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทเครื่อง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMMachineProductCode'"
                    :name="'rePMMachineProductCode'"
                    :select2-options="rePMMachineProductCodeOptions"
                    multiple
                    v-model="rePMMachineProductCode"
                  ></select2> -->
                  <treeselect
                    v-model="rePMMachineProductCode"
                    :multiple="true"
                    :options="rePMMachineProductCodeOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Type(เครื่อง):</label>
                  <treeselect
                    v-model="rePMMachineType"
                    :multiple="true"
                    :options="rePMMachineOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>BARCODE (หัวจ่าย):</label>
                  <input
                    v-model="rePMDisBarcode"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทหัวจ่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMDispenserProductCode'"
                    :name="'rePMDispenserProductCode'"
                    :select2-options="rePMDispenserProductCodeOptions"
                    multiple
                    v-model="rePMDispenserProductCode"
                  ></select2> -->
                  <treeselect
                    v-model="rePMDispenserProductCode"
                    :multiple="true"
                    :options="rePMDispenserProductCodeOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Type(หัวจ่าย):</label>
                  <treeselect
                    v-model="rePMDispenserType"
                    :multiple="true"
                    :options="rePMDispenserOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <label>Brand:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMBrand'"
                    :name="'rePMBrand'"
                    :select2-options="rePMBrandOptions"
                    multiple
                    v-model="rePMBrand"
                  ></select2> -->
                  <treeselect
                    v-model="rePMBrand"
                    :multiple="true"
                    :options="rePMBrandOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>หัวจ่ายที่ล้าง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMPMBrand'"
                    :name="'rePMPMBrand'"
                    :select2-options="rePMPMBrandOptions"
                    multiple
                    v-model="rePMPMBrand"
                  ></select2> -->
                  <treeselect
                    v-model="rePMPMBrand"
                    :multiple="true"
                    :options="rePMPMBrandOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- NEW -->
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMProvinceId'"
                    :name="'rePMProvinceId'"
                    :select2-options="rePMProvinceIdOptions"
                    @selectChange="onAmpherIdChange"
                    v-model="rePMProvinceId"
                    ref="rePMProvinceIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMAmpherId'"
                    :name="'rePMAmpherId'"
                    :select2-options="rePMAmpherIdOptions"
                    v-model="rePMAmpherId"
                    ref="rePMAmpherIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ร้านค้า:</label>
                  <input
                    v-model="rePMShopName"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อร้านค้า เช่น ชื่อร้านค้า1,ชื่อร้านค้า2"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <treeselect
                    v-model="rePMShopTypeId"
                    :multiple="true"
                    :options="rePMShopTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะประเภทร้านค้า:</label>
                  <treeselect
                    v-model="shmShopGroupId"
                    :multiple="true"
                    :options="shmShopGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทการล้างเครื่อง:</label>
                  <treeselect
                    v-model="shmPMTypeId"
                    :multiple="true"
                    :options="shmPMTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

               <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <!-- <label>Status:</label> -->
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMStatus'"
                    :name="'rePMStatus'"
                    :select2-options="rePMStatusOptions"
                    v-model="rePMStatus"
                  ></select2>
                </div>
              </div>

              <!-- CR-PM-ViewImage item 3: checkbox รูปแบบแสดงรูปภาพ (แถวเดียวกับ สถานะ) -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>&nbsp;</label>
                  <label style="margin-top:8px;display:flex;align-items:center;cursor:pointer;font-weight:500;">
                    <input type="checkbox" v-model="rePMShowImages" @change="onShowImagesChange" style="margin-right:8px;transform:scale(1.2);" />
                    รูปแบบแสดงรูปภาพ
                  </label>
                </div>
              </div>

            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset($event)"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportPM"
                  type="submit"
                  :disabled="isExporting"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="pmTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="27">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ประเภทตัวแทนจำหน่าย</th>

                    <!-- <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th> -->
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">Route ID</th>
                    <th class="all text-center">ชื่อรูท</th>
                    <th class="all text-center">ชื่อผู้ใช้งาน</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">ประเภทการล้างเครื่อง</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">สถานะประเภทร้านค้า</th>
                    <!-- <th class="all text-center">รหัสบาร์โค้ด เครื่อง</th> -->
                    <th class="all text-center">BARCODE (เครื่องทำความเย็น)</th>
                    <th class="all text-center">ประเภทเครื่องทำความเย็น</th>
                    <th class="all text-center">Type (เครื่องทำความเย็น)</th>
                    <!-- <th class="all text-center">รหัสบาร์โค้ด หัวจ่าย</th> -->
                    <th class="all text-center">BARCODE (หัวจ่าย)</th>
                    <th class="all text-center">ประเภทหัวจ่าย</th>
                    <th class="all text-center">Type (หัวจ่าย)</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">จำนวนหัวจ่าย</th>
                    <th class="all text-center">หัวจ่ายที่ล้าง</th>
                    <th class="all text-center">จำนวนหัวจ่ายที่ล้าง</th>
                    <th class="all text-center">มาตรฐานการล้าง(วัน)</th>
                    <th class="all text-center">วันที่การล้างเครื่อง(PM)</th>
                    <th class="all text-center">วันที่การล้างเครื่อง(PM) รอบถัดไป</th>
                    <th class="all text-center">ดาวน์โหลด</th>
                    <!-- <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">อำเภอ</th>
                    <th class="all text-center">ประเภทร้านค้า</th> -->
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      isExporting: false, // 2026-08-10: disable ปุ่ม Export ระหว่างประมวลผล (กันกดซ้ำ)
      rePMShopTypeId: [],
      shmShopGroupId: [],
      rePMProvinceId: null,
      rePMAmpherId: null,
      rePMShopName: null,
      reAaIsInitial: true,
      reAaDateReq: null,
      rePMAgentCode: [],
      rePMSubAgentCode: [],
      rePMRegion: [],
      rePMPMBrand: [],
      rePMShowImages: false, // CR-PM-ViewImage item 3: default ไม่ติ๊ก (ไม่แสดงรูป) — ไม่ cap, default 1 ของเดือน
      rePMDateStart: moment().startOf("month"), // item 3: default ไม่ติ๊ก = วันที่ 1 ของเดือนปัจจุบัน
      rePMDateEnd: moment(),
      rePMDateStartError: null,
      rePMDateEndError: null,
      rePMCreatedUserId: [],
      rePMNFC: [],
      rePMBarcode: null,
      reAaProductBrand: [],
      rePMMachineProductCode: [],
      rePMDisBarcode: null,
      rePMDispenserProductCode: [],
      rePMStatus: null,
      rePMBrand: [],
      rePMBrand: [],
      rePMCreatedUserIdOptions: [],
      rePMBarcodeOptions: [],
      rePMMachineProductCodeOptions: [],
      rePMAgentCodeOptions: [],
      rePMRegionOptions: [],
      
      pmrSubAgentCodes : [],
      rePMSubAgentCodeOptions : [],
      pmrPmUserIdOptions : [],

      shmPMTypeId : [] ,
      shmPMTypeIdOptions : [] ,

      
      pmrPmUserIdOptions: {
        placeholder: "กรุณาเลือกผู้ดำเนินการ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.rePMAgentCode,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      rePM3Options: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      rePMDisBarcodeOptions: [],
      rePMDispenserProductCodeOptions: [],

      rePMStatusOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือก Status",
        allowClear: true,
        data: [
          {
            id: false,
            text: "ร้านเปิด",
            data: null,
          },
          {
            id: true,
            text: "ร้านปิด",
            data: null,
          },
        ],
      },
      rePMBrandOptions: [],
      rePMPMBrandOptions: [],
      rePMMachineType: [],
      rePMMachineOptions: [
        {
          id: "บริษัท",
          label: "บริษัท",
        },
        {
          id: "เครื่องเช่า",
          label: "เครื่องเช่า",
        },
        {
          id: "ส่วนบุคคล",
          label: "ส่วนบุคคล",
        },
      ],
      rePMDispenserType: [],
      rePMDispenserOptions: [
        {
          id: "บริษัท",
          label: "บริษัท",
        },
        {
          id: "เครื่องเช่า",
          label: "เครื่องเช่า",
        },
        {
          id: "ส่วนบุคคล",
          label: "ส่วนบุคคล",
        },
      ],
      rePMShopTypeIdOptions: [], 
      shmShopGroupIdOptions: [],
      rePMProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      rePMAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.rePMProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.rePMAgentCode = [];
      self.rePMRegion = [];
      self.rePMShowImages = false; // item 3: reset = ไม่ติ๊ก
      self.rePMDateStart = moment().startOf("month"); // item 3: default ไม่ติ๊ก = วันที่ 1 ของเดือน
      self.rePMDateEnd = moment();
      self.rePMCreatedUserId = [];
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;
      self.rePMBarcode = null;
      self.rePMMachineProductCode = [];
      self.rePMDisBarcode = null;
      self.rePMDispenserProductCode = [];
      self.rePMStatus = null;
      self.rePMBrand = [];
      self.rePMPMBrand = [];
      self.rePMNFC = [];
      self.rePMMachineType = [];
      self.rePMDispenserType = [];
      self.rePMProvinceId = null;
      self.rePMAmpherId = null;
      self.rePMShopName = null;
      self.rePMShopTypeId = [];
      self.shmShopGroupId = [];
      self.rePMBarcode = null;
      self.shmPMTypeId = [] ;
      

      $("#rePMAmpherId")
        .val("")
        .trigger("change");

      $("#rePMProvinceId")
        .val("")
        .trigger("change");

      $("#rePMAgentCode")
        .val("")
        .trigger("change");

      $("#rePMRegion")
        .val("")
        .trigger("change");

      $("#rePM3")
        .val("")
        .trigger("change");

      $("#rePMCreatedUserId")
        .val("")
        .trigger("change");

      $("#reAaProductBrand")
        .val("")
        .trigger("change");

      $("#rePMMachineProductCode")
        .val("")
        .trigger("change");

      $("#rePMDispenserProductCode")
        .val("")
        .trigger("change");

      $("#rePMStatus")
        .val("")
        .trigger("change");

      $("#rePMBrand")
        .val("")
        .trigger("change");

      $("#rePMPMBrand")
        .val("")
        .trigger("change");

      // 2026-06-24 Bug fix: sync bootstrap-datepicker input DOM กับ Vue model
      //   เดิมตั้ง self.rePMDateStart = null แต่ datepicker ไม่ react → input ค้างค่าเดิม
      if (self.$refs.rePMDateStart) {
        $(self.$refs.rePMDateStart).datepicker("update", self.rePMDateStart.format("DD/MM/YYYY"));
      }
      if (self.$refs.rePMDateEnd) {
        $(self.$refs.rePMDateEnd).datepicker("update", self.rePMDateEnd.format("DD/MM/YYYY"));
      }

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();

      // 2026-06-24: required date validation (skip บน reset)
      if (innerText != "ล้างค่าทั้งหมด" && !self.validatePMDateRequired()) return;

      // 2026-08-25: ตัด confirm 180 วันออกตาม user → search ได้เลย (cap 7 วันตอนติ๊กแสดงรูปยังอยู่ใน validate)
      $("#pmTable").DataTable().draw();
    },

    // 2026-06-24: validate วันที่ทั้ง 2 ฟิลด์ — required
    //   อ่านค่าจาก input DOM โดยตรง — bootstrap-datepicker บางครั้ง changeDate event
    //   ไม่ทัน sync ลง Vue model ทำให้ self.rePMDateStart ยังเป็น null แม้ input มีค่า
    validatePMDateRequired: function() {
      let self = this;
      // reset inline errors
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;

      var startInputVal = self.$refs.rePMDateStart ? $(self.$refs.rePMDateStart).val().trim() : "";
      var endInputVal = self.$refs.rePMDateEnd ? $(self.$refs.rePMDateEnd).val().trim() : "";

      // Sync Vue model จาก DOM ถ้า out of sync (กัน .format() error ตอน DataTables ส่ง request)
      if (!self.rePMDateStart && startInputVal) {
        self.rePMDateStart = moment(startInputVal, "DD/MM/YYYY");
      }
      if (!self.rePMDateEnd && endInputVal) {
        self.rePMDateEnd = moment(endInputVal, "DD/MM/YYYY");
      }

      // item 2 (2026-08-24): required เฉพาะเมื่อ "แสดงรูปภาพ" (ติ๊ก) · ไม่ติ๊ก = วันที่ว่างได้ ไม่มี red → ใช้ confirm 180 วันแทน
      if (self.rePMShowImages) {
        var hasErr = false;
        if (!self.rePMDateStart) {
          self.rePMDateStartError = "กรุณาเลือกวันที่เริ่มต้น";
          hasErr = true;
        }
        if (!self.rePMDateEnd) {
          self.rePMDateEndError = "กรุณาเลือกวันที่สิ้นสุด";
          hasErr = true;
        }
        if (hasErr) return false;
      }

      // 2026-08-09: cap ช่วงไม่เกิน 7 วัน (checkDateRangeMax7 คืน true ถ้าไม่ติ๊ก)
      if (!self.checkDateRangeMax7()) return false;

      return true;
    },
    // 2026-08-09: เช็คช่วงไม่เกิน 7 วัน + alert — ใช้ทั้งตอน datechange และตอน validate (Generate/Export)
    checkDateRangeMax7: function() {
      var self = this;
      // item 3: cap 7 วัน เฉพาะเมื่อ "แสดงรูปภาพ" (ติ๊ก) · ไม่ติ๊ก = ไม่จำกัดวันที่
      if (!self.rePMShowImages) return true;
      if (!self.rePMDateStart || !self.rePMDateEnd) return true;
      var diffDays = moment(self.rePMDateEnd).startOf("day").diff(moment(self.rePMDateStart).startOf("day"), "days");
      if (diffDays > 7) {
        Swal.fire(
          "แจ้งเตือน",
          "เลือกดูข้อมูลได้สูงสุดไม่เกิน 7 วัน เพื่อไม่ให้ส่งผลกระทบต่อการทำงานโดยรวมของระบบ กรุณาแก้ไขวันที่",
          "warning"
        );
        return false;
      }
      return true;
    },
    // CR-PM-ViewImage item 3: toggle "แสดงรูปภาพ" → set default วันที่ตามโหมด
    onShowImagesChange: function() {
      var self = this;
      if (self.rePMShowImages) {
        self.rePMDateStart = moment().subtract(7, "days"); // แสดงรูป → ย้อนหลัง 7 วัน (+ cap 7 วัน)
      } else {
        self.rePMDateStart = moment().startOf("month");    // ไม่แสดงรูป → วันที่ 1 ของเดือน (ไม่ cap)
      }
      self.rePMDateEnd = moment();
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;
      // A-01: sync ค่าเข้า datepicker UI (ไม่งั้น model เปลี่ยนแต่ input ค้างค่าเดิม) — pattern เดียวกับ formReset
      if (self.$refs.rePMDateStart) {
        $(self.$refs.rePMDateStart).datepicker("update", self.rePMDateStart.format("DD/MM/YYYY"));
      }
      if (self.$refs.rePMDateEnd) {
        $(self.$refs.rePMDateEnd).datepicker("update", self.rePMDateEnd.format("DD/MM/YYYY"));
      }
    },
    exportPM: function(e) {
      e.preventDefault();
      let self = this;

      // 2026-06-24: required date validation
      if (!self.validatePMDateRequired()) return;

      // CR-PM-2026 Perf: 2-stage progress message (image download phase อาจใช้เวลา 30-60s)
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังประมวลผลข้อมูล กรุณารอสักครู่...",
      });

      // Stage 2: switch ข้อความหลัง 8s (SQL ~3s + Excel write ~5s → เริ่ม download image)
      //   2026-09-01: ตั้ง timer เฉพาะเมื่อติ๊ก "รูปแบบแสดงรูปภาพ" — ไม่ติ๊ก = ไม่ฝังรูปใน Excel จึงไม่ควรขึ้น dialog ประมวลผลรูป
      let stage2Timer = self.rePMShowImages
        ? setTimeout(function() {
            KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังประมวลผลรูปภาพ กรุณารอสักครู่...",
            });
          }, 8000)
        : null;   // clearTimeout(null) = no-op → ท้าย axios ไม่ต้องแก้

      self.isExporting = true;
      axios({
        method: "post",
        url: "/Api/Report/ExportPM",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.rePMAgentCode,
          SubAgentCode: self.rePMSubAgentCode,
          Department: self.rePMRegion,
          DateStart:
            self.rePMDateStart != null
              ? self.rePMDateStart.format("DD/MM/YYYY")
              : null,
          DateEnd:
            self.rePMDateEnd != null
              ? self.rePMDateEnd.format("DD/MM/YYYY")
              : null,
          ShowImages: self.rePMShowImages, // item 3: true=ฝัง thumbnail, false=data-only (คง link column)
          CreatedUserId: self.rePMCreatedUserId,
          NFCCode: self.rePMNFC,
          MachineBarcodeNo: self.rePMBarcode ? self.rePMBarcode.split(",").map(s => s.trim()) : [],
          MachineProductCode: self.rePMMachineProductCode,
          DispenserBarcodeNo: self.rePMDisBarcode ? self.rePMDisBarcode.split(",").map(s => s.trim()) : [],
          DispenserProductCode: self.rePMDispenserProductCode,
          InActive: self.rePMStatus,
          Brand: self.rePMBrand,
          PMBrand: self.rePMPMBrand,
          MachineType: self.rePMMachineType,
          DispenserType: self.rePMDispenserType,
          ShopTypeId: self.rePMShopTypeId,
          ShopGroupId: self.shmShopGroupId,
          ProvinceId: self.rePMProvinceId,
          AmpherId: self.rePMAmpherId,
          ShopName: self.rePMShopName,
          PMTypes : self.shmPMTypeId
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            } 

            var fname = filename.split("RPT_")[1] ;   

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "รายงานข้อมูลการล้างเครื่องเบียร์สด(PM)_" + fname //+ filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          clearTimeout(stage2Timer);
          KTApp.unblockPage();
          self.isExporting = false;
        });
    },
    // LoadrePMCreatedUserIdOptions: function(e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Report/PM/UserNameOptions", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.rePMCreatedUserIdOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // },
    
    LoadrePMBarcodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.rePMBarcodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2Barcode", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
              OnlyMachine: true,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.rePMBarcodeOptions = [];
              data.forEach((element) => {
                self.rePMBarcodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.rePMBarcodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadrePMMachineProductCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            productTypeId: 3,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMMachineProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMSubAgentCodeOptions: function(e) {
      var self = this; 
      self.rePMSubAgentCodeOptions = [{id:"", label:"Loading...",isDisabled:true}];
      axios
        .post(
          "/Api/Report/Select2SubShopAgent",
          {
            agentCodes: self.rePMAgentCode, 
            page:  1,
          }
        )
        .then(function(response) {
           
          if (response.status == 200) {
            self.rePMSubAgentCodeOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMSubAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMAgentCodeOptions: function(e) {
      var self = this;
      self.rePMAgentCodeOptions = [{id:"", label:"Loading...",isDisabled:true}];
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: self.rePMRegion,
            AgentCodes: [],
            page: 1,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            self.rePMAgentCodeOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMRegionOptions: function(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.rePMRegionOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMRegionOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMDisBarcodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.rePMDisBarcodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2Barcode", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
              OnlyDispenser: true,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.rePMDisBarcodeOptions = [];
              data.forEach((element) => {
                self.rePMDisBarcodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.rePMDisBarcodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadrePMDispenserProductCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            productTypeId: 6,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMDispenserProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMBrandOptions: function(e) {
      var self = this;
      axios//BrandOptions
        .get("/Api/Report/PM/ProductBrandOptions", {
          params: {
            page: 1,
            productTypeId: 6,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMPMBrandOptions: function(e) {
      var self = this;
      axios//PM/PMBrandOptions
        .get("/Api/Report/PM/ProductBrandOptions", {
          params: {
            page: 1,
            productTypeId: 6,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMPMBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function() {
      $(`[class="vue-treeselect__input"]`).val("");
    },
    LoadShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    LoadPMTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Select2MasterShopTypePM", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmPMTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    LoadShopGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    onAmpherIdChange: function() {
      $("#rePMAmpherId")
        .val("")
        .trigger("change");
    },
  },
  async mounted() {
    let self = this;

    //self.LoadrePMCreatedUserIdOptions();
    self.LoadrePMMachineProductCodeOptions();
    self.LoadrePMAgentCodeOptions();
    self.LoadrePMRegionOptions();
    self.LoadrePMDispenserProductCodeOptions();
    self.LoadrePMBrandOptions();
    self.LoadrePMPMBrandOptions();
    self.LoadShopTypeIdOptions();
    self.LoadShopGroupIdOptions();
    self.LoadPMTypeIdOptions();

    self.rePMStatus = false ;
    $("#rePMStatus")
        .val("false")
        .trigger("change");


    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.rePMDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(this.$refs.rePMDateStart).datepicker("setDate", this.rePMDateStart.toDate());
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.rePMDateStart)
      .datepicker(
        "update",
        !!self.rePMDateStart ? self.rePMDateStart.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.rePMDateStart = e.dates.length != 0 ? moment(e.date) : null;
        self.checkDateRangeMax7();
      });

    $(self.$refs.rePMDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(this.$refs.rePMDateEnd).datepicker("setDate", this.rePMDateEnd.toDate());
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.rePMDateEnd)
      .datepicker(
        "update",
        !!self.rePMDateStart ? self.rePMDateEnd.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.rePMDateEnd = e.dates.length != 0 ? moment(e.date) : null;
        self.checkDateRangeMax7();
      });

    var table = $("#pmTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/PM",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              AgentCode: self.rePMAgentCode,
              SubAgentCode: self.rePMSubAgentCode,
              Department: self.rePMRegion,
              DateStart:
                self.rePMDateStart != null
                  ? self.rePMDateStart.format("DD/MM/YYYY")
                  : null,
              DateEnd:
                self.rePMDateEnd != null
                  ? self.rePMDateEnd.format("DD/MM/YYYY")
                  : null,
              CreatedUserId: self.rePMCreatedUserId,
              NFCCode: self.rePMNFC,
              MachineBarcodeNo: self.rePMBarcode ? self.rePMBarcode.split(",").map(s => s.trim()) : [],
              MachineProductCode: self.rePMMachineProductCode,
              DispenserBarcodeNo: self.rePMDisBarcode ? self.rePMDisBarcode.split(",").map(s => s.trim()) : [],
              DispenserProductCode: self.rePMDispenserProductCode,
              InActive: self.rePMStatus,
              Brand: self.rePMBrand,
              PMBrand: self.rePMPMBrand,
              MachineType: self.rePMMachineType,
              DispenserType: self.rePMDispenserType,
              IsInitial: self.reAaIsInitial,
              AgentCode: self.rePMAgentCode,
              ShopTypeId: self.rePMShopTypeId,
              ShopGroupId: self.shmShopGroupId,
              ProvinceId: self.rePMProvinceId,
              AmpherId: self.rePMAmpherId,
              ShopName: self.rePMShopName,
              PMTypes : self.shmPMTypeId
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        // order: [[0, "desc"]],
        order: [[4, "desc"]],
        columns: [
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-center" },
          {
            data: "agentType",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.agentTypeName;
            },
          },
          { data: "department", className: "text-center" },
          { data: "routePlanShopRunningNumber", className: "text-center" },
          { data: "routeName", className: "text-center" },
          { data: "createdUser", className: "text-center" },
          { data: "shopCode", className: "text-center" },
          { 
            data: "name1", 
            className: "text-center",
            render: function(data, type, full, meta) {
              return data.replace(/\s/g, '&nbsp;');
            } 
          },
          { 
            data: "name2", 
            className: "text-center" ,
            render: function(data, type, full, meta) {
              return data.replace(/\s/g, '&nbsp;');
            } 
          }, 
           {
            data: "pmStartDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              if(full.agentType=="AGENT")
                   return full.shopPMTypeName;
              else
                  return full.subShopPMTypeName;
            },
          }, 
          { data: "shopTypeName", className: "text-center" },
          { data: "shopGroupName", className: "text-center" },
        //  { data: "machineBarcodeNo", className: "text-center" },
          { data: "machineBarcodeNoOld", className: "text-center" },
          { data: "machineProductName", className: "text-center" },
          { data: "machineType", className: "text-center" },
          //{ data: "dispenserBarcodeNo", className: "text-center" },
          { data: "dispenserBarcodeNoOld", className: "text-center" },
          { data: "dispenserProductName", className: "text-center" },
          { data: "dispenserType", className: "text-center" },
          { data: "brandString", className: "text-center" },
          { data: "brandCount", className: "text-center" },
          { data: "pmBrandString", className: "text-center" },
          { data: "pmCount", className: "text-center" },
          // Issue #25: มาตรฐานการล้าง(วัน), วันที่ PM, วันที่ PM รอบถัดไป
          { data: "standardCleaningDays", className: "text-center" },
          {
            data: "pmStartDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.pmStartDateString;
            },
          },
          {
            data: "nextPMDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return data ? moment(data).format("DD/MM/YYYY") : "";
            },
          },
          {
            // A-02: View & Download → เปิด gallery เดียวกับ Excel (mirror WritePMImageLink) — ไม่มีรูปครบ 3 = ไม่มี link
            data: "cleanUpConnectFileInfoId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              var c = full.cleanUpConnectFileInfoId || "";
              var d = full.cleanUpDisassembleFileInfoId || "";
              var e = full.cleanUpExternalFileInfoId || "";
              if (!c && !d && !e) return "";
              var ids = [c, d, e].map(function(s){ return encodeURIComponent(s); }).join(",");
              // redesign 2026-08-24: ร้านค้า = [code] name1 (name2 แยกไป shop2) + ตัวแทน/ประเภทเครื่อง-หัวจ่าย/BARCODE หัวจ่าย
              var shop = ("[" + (full.shopCode || "") + "] " + (full.name1 || "")).trim();
              // S1: machine bc/type + dispenser bc/type = group-aggregated (PMGalleryAggregate) → กด link row ไหนในกลุ่มก็ data ตรงกัน
              var url = "/Api/File/ViewPMImages?ids=" + ids
                      + "&shop=" + encodeURIComponent(shop)
                      + "&barcode=" + encodeURIComponent(full.galleryMachineBarcode || "")
                      + "&pmdate=" + encodeURIComponent(full.pmStartDateString || "")
                      + "&user=" + encodeURIComponent(full.createdUser || "")
                      + "&shop2=" + encodeURIComponent(("[" + (full.shopCode || "") + "] " + (full.name2 || "")).trim())
                      + "&agent=" + encodeURIComponent(full.agentName || "")
                      + "&machinetype=" + encodeURIComponent(full.galleryMachineType || "")
                      + "&dispenserbc=" + encodeURIComponent(full.galleryDispenserBarcodesCsv || "")
                      + "&dispensertype=" + encodeURIComponent(full.galleryDispenserTypesCsv || "")
                      + "&bsmid=" + encodeURIComponent(full.barcodeShopMappingId || "");   // I-3: gallery lookup Index → "ชุดที่ N"
              return '<a href="' + url + '" target="_blank" style="color:#0563C1;font-weight:600;text-decoration:underline;">View &amp; Download</a>';
            },
          },
          // { data: "provinceName", className: "text-center" },
          // { data: "ampherName", className: "text-center" },
          // { data: "shopTypeName", className: "text-center" },
        ],
        drawCallback: function(settings) {
          self.reAaIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/PM.vue